import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_BusTrackerGeoFenceMaintenance } from "../shared/data.service";
import { GeoFenceModifyRequest } from "../shared/GeoFenceModifyRequest";

@Component({
	selector: "app-edit-geo-fence",
	templateUrl: "./edit-geo-fence.component.html",
	styleUrls: ["./edit-geo-fence.component.css"],
})
export class EditGeoFenceComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private mapService: DataService_BusTrackerGeoFenceMaintenance
	) {}

	ngOnInit(): void {
		this.lstPoints = this.dialogConfig.data.lstPoints;
		this.NewFenceColor = this.dialogConfig.data.NewFenceColor;
		this.NewOpacity = this.dialogConfig.data.NewOpacity;
		this.GeoFence = this.dialogConfig.data.GeoFence;

		this.GeoFenceID = this.GeoFence.GeoFenceID;
		this.GeoFenceDesc = this.GeoFence.GeoFenceDesc;
		this.AlertComments = this.GeoFence.AlertComments;
		this.Active = this.GeoFence.Active;

		this.loadBus();
	}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	GeoFence: any;
	GeoFenceID: any;
	GeoFenceDesc: any = "";
	NewFenceColor: any;
	NewOpacity: any;
	Active: any = false;

	BusLoading: any = true;
	Bus: any;
	lstBus: any = [];

	TriggerLoading: any = true;
	GeoFenceTriggerType: any;
	lstGeoFenceTriggerType: any = [];

	SeverityLoading: any = true;
	Severity: any;
	lstSeverity: any = [];

	AlertComments: any = "";

	lstPoints: any = [];

	Processing: any = false;
	errorMessage: any = "";

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////
	loadBus() {
		this.BusLoading = true;

		var result = this.mapService.BusSelectorSelectList();
		result.subscribe(
			(response) => {
				this.lstBus = response;
				this.Bus = this.lstBus[0];

				for (var z = 0; z < this.lstBus.length; z++) {
					var next = this.lstBus[z];

					if (next.BusID == this.GeoFence.BusID) {
						this.Bus = next;
						break;
					}
				}

				this.BusLoading = false;

				this.loadTriggerType();
			},
			(error) => {
				this.BusLoading = false;
			}
		);
	}

	loadTriggerType() {
		this.TriggerLoading = true;

		var result = this.mapService.GeoFenceTriggerTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstGeoFenceTriggerType = response;
				this.GeoFenceTriggerType = this.lstGeoFenceTriggerType[0];

				for (var z = 0; z < this.lstGeoFenceTriggerType.length; z++) {
					var next = this.lstGeoFenceTriggerType[z];

					if (next.GeofenceTriggerTypeID == this.GeoFence.GeofenceTriggerTypeID) {
						this.GeoFenceTriggerType = next;
						break;
					}
				}

				this.TriggerLoading = false;

				this.loadSeverity();
			},
			(error) => {
				this.TriggerLoading = false;
			}
		);
	}

	loadSeverity() {
		this.SeverityLoading = true;

		var result = this.mapService.SeveritySelectList();
		result.subscribe(
			(response) => {
				this.lstSeverity = response;
				this.Severity = this.lstSeverity[0];

				for (var z = 0; z < this.lstSeverity.length; z++) {
					var next = this.lstSeverity[z];

					if (next.ID == this.GeoFence.Severity) {
						this.Severity = next;
						break;
					}
				}

				this.SeverityLoading = false;
			},
			(error) => {
				this.SeverityLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		if (this.AlertComments.length > 256) {
			this.errorMessage = "Alert Comments must be <= 256 charcters";
		}

		//
		// Create Request
		//

		var lstLat: string[] = [];
		var lstLong: string[] = [];

		for (var z = 0; z < this.lstPoints.length; z++) {
			var next = this.lstPoints[z];

			//
			// Markers/points only (Will error trying to read polygon)
			// (Fill color only exists on polygons/shapes)
			//
			if (next.fillColor == undefined) {
				lstLat = [...lstLat, next.position.lat()];
				lstLong = [...lstLong, next.position.lng()];
			}
		}

		//
		// Complete polygon
		// (Start and end must be the same)
		//
		lstLat = [...lstLat, lstLat[0]];
		lstLong = [...lstLong, lstLong[0]];

		let parms: GeoFenceModifyRequest = {
			GeoFenceID: this.GeoFenceID,
			GeoFenceDesc: this.GeoFenceDesc,
			FillColor: this.NewFenceColor,
			AlphaChannel: this.NewOpacity,
			BusID: this.Bus.BusID,
			GeoFenceTriggerTypeID: this.GeoFenceTriggerType.GeofenceTriggerTypeID,
			Severity: this.Severity.ID,
			AlertComments: this.AlertComments,
			Active: this.Active == true ? 1 : 0,
			lstPointLats: lstLat,
			lstPointLongs: lstLong,
		};

		//
		// Call SP
		//
		this.Processing = true;

		var result = this.mapService.GeoFenceUpdate(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (this.AllClear(response) == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Geo Fence was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Geo Fence: " + response,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.BusLoading == true || this.TriggerLoading == true || this.SeverityLoading == true || this.Processing == true;
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	///////////////////////////////////////////////////////////////////////////
}
